import React, { Component } from 'react';
import CustomLoader from '../common/CustomLoader';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { iconForField } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class CollectionAccordian extends Component {
  render() {
    const {
      title,
      children,
      showCollectionFieldDeleteLoader,
      isPluginField,
      deleteField,
      isSubmitting,
      fieldName,
      restrictEdit,
      fieldFlag,
      readRoles,
      writeRoles,
      projectId,
    } = this.props;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb ${iconForField(this.props.type)}`} /> <strong>{title}</strong>
            {isPluginField && fieldName === 'tenantId' && ' (tenant default)'}
            {isPluginField && fieldName === 'subTenantId' && ' (Sub Tenant default)'}
            {((readRoles && readRoles.length > 0) || (writeRoles && writeRoles.length > 0)) && (
              <span className="ml-2">
                <small>
                  {'('}
                  {readRoles && readRoles.length > 0 && `Read: ${readRoles.join(', ')}`}
                  {readRoles && readRoles.length > 0 && writeRoles && writeRoles.length > 0 && ', '}
                  {writeRoles && writeRoles.length > 0 && `Write: ${writeRoles.join(', ')}`}
                  {')'}
                </small>
              </span>
            )}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="row">
            <div className="col-12">{children}</div>
            <div className="col-12 text-right">
              {!isPluginField && (
                <button
                  type="reset"
                  className="btn btn-theme-delete btn-md"
                  style={{ cursor: fieldFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                  disabled={showCollectionFieldDeleteLoader || isReadOnly}
                  onClick={fieldFlag && !isReadOnly ? deleteField : undefined}
                >
                  <i className="wb webconnect-trash-regular"></i> Delete
                  {fieldFlag ? null : (
                    <>
                      &nbsp;
                      <TooltipInfo
                        title={description}
                        headerText={`Permission Disabled!`}
                        showHeader={true}
                        showArrow={true}
                      />
                    </>
                  )}
                  <CustomLoader loading={showCollectionFieldDeleteLoader} />
                </button>
              )}{' '}
              {!(
                isPluginField &&
                fieldName &&
                [
                  'tenantId',
                  'userSettingId',
                  'permissions',
                  'userRoles',
                  'userId',
                  'subTenantId',
                ].includes(fieldName)
              ) && (
                <button
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                  disabled={isSubmitting || isReadOnly}
                >
                  <i className="wb webconnect-save-regular"></i>{' '}
                  {title && title !== 'New Field' ? 'Update' : 'Save'}
                </button>
              )}
            </div>
          </div>
        </AccordionItemPanel>
      </>
    );
  }
  // }
}

export default CollectionAccordian;
